<template>
  <div>
    <!-- ====== Alterar Pin ====== -->
    <b-row>
      <b-col cols="12" class="mt-4">

        <el-card class="box-card dashboard-card">

          <div slot="header">
            <span>PIN (Usado para confirmar a transferência de saque)</span>

            <el-button
              :disabled="editPin"
              class="text-primary"
              @click="editPin = true"
              style="float: right; padding: 3px 10px"
              :type="!editPin ? 'defauld' : 'primary'"
              icon="el-icon-edit">
              Cadastrar PIN
            </el-button>

          </div>
          <el-alert
            class="mb-3"
            title="O cadastro de um novo PIN, substituirá o atual, caso tenha cadastrado anteriormente!"
            type="info">
          </el-alert>

          <el-form :model="pin" :rules="pinRules" ref="pin"
                   size="small" class="checkout-form dashboard-form pl-1 pr-1">

            <el-row :gutter="20" class="">

              <el-col :span="24" :md="12">
                <el-form-item label="Sua senha" prop="password">
                  <el-input
                    placeholder="Digite sua senha"
                    v-model="pin.password"
                    show-password
                    :readonly="!editPin"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="24" :md="12">
                <el-form-item label="PIN (4 digitos. Somente números!)" prop="pin">
                  <div class="el-input el-input--small">
                    <el-input
                      v-model="pin.pin"
                      maxlength="4"
                      type="pin"
                      placeholder="Informe o PIN"
                    ></el-input>
                  </div>
                </el-form-item>
              </el-col>

              <el-col v-show="editPin" :span="24" class="text-center">

                <el-button
                  :disabled="!editPin"
                  @click="submitPin('pin')"
                  :round="true"
                  :loading="loading.savePass"
                  type="primary"
                  size="mini"
                  class="w-50 text-uppercase font-weight-bold"
                >
                  Cadastrar PIN
                </el-button>

                <el-button
                  :disabled="!editPin"
                  @click="editPin = false"
                  :round="true"
                  :loading="false"
                  type="info"
                  plain
                  size="mini"
                  class="text-uppercase font-weight-bold"
                >
                  Cancelar
                </el-button>

              </el-col>
            </el-row>
          </el-form>

        </el-card>
      </b-col>
    </b-row>

  </div>
</template>

<script>
import {mask} from 'vue-the-mask'
import {onlyNumber} from "@/helpers";
import UserService from "@/services/user.service";


export default {
  name: 'Pin',
  directives: {mask},
  data() {
    return {
      onlyNumber,
      loading: {
        savePin: false
      },
      editPin: false,
      pin: {
        password: '',
        pin: '',
      },
      pinRules: {
        password: [
          {required: true, message: 'Por favor, digite sua senha atual', trigger: 'blur'},
        ],
        pin: [
          {required: true, validator: this.validatePin, trigger: 'blur'},
        ],
      },
      baseUrl: process.env.VUE_APP_BASE_URL,
      apiV1: process.env.VUE_APP_API_V1,
    }
  },
  async mounted() {


  },
  methods: {
    validatePin(rule, value, callback) {

      if (!value) {
        return callback(new Error('Digite o PIN'));
      }

      if (value.length < 4) {
        return callback(new Error('Informe 4 digitos!'));
      }

      if (value.length > 4) {
        return callback(new Error('Somente 4 digitos!'));
      }

      let cb;

      switch (value) {
        case '1111':
        case '2222':
        case '3333':
        case '4444':
        case '5555':
        case '6666':
        case '7777':
        case '8888':
        case '9999':
        case '0000':
          cb = 'Não cadastre números iguais!';
          break
      }

      if (cb) {
        return callback(new Error('Não cadastre números iguais!'));
      }

      if (!value) {
        return callback(new Error('Digite o valor'));
      }

      callback()

    },

    submitPin(formName) {

      this.$refs[formName].validate(async (valid) => {

        this.loading.savePin = true;

        if (valid) {

          const {password, pin} = this.pin;
          const data = {
            password,
            pin
          };
          const sendPin = await UserService.setPin(data)

          if (sendPin) {
            this.$message({
              message: sendPin.data.message,
              type: 'success'
            });
            this.loading.savePass = false;
            this.editPin = false;
            this.resetForm(formName)
          }

        } else {
          this.loading.savePass = false;
          return false;
        }
      });
    },

    checkPass(rule, value, callback) {
      if (!value) {
        return callback(new Error('Digite sua nova senha'));
      }
      if (value.length < 6) {
        callback(new Error('Mínimo de 6 caracteres'));
      }
      if (value.length > 12) {
        callback(new Error('Máximo de 12 caracteres'));
      }

      callback();
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },

  },
  watch: {
    'pin.pin': function (e) {
      if (e) {
        this.pin.pin = onlyNumber(e)
      }
    }
  }
}
</script>

<style scoped>

</style>
